module.exports = __webpack_public_path__ + "static/media/gryphon_musee_hero_currentexhibition_1.68ab93b3.jpg";